import { Box, Divider, ListSubheader, MenuItem } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { SearchableSelectProps } from "./types";

export const renderOptions = <T,>(
  props: SearchableSelectProps<T>,
  label: string,
  options: T[],
  lineBreak: boolean,
) => {
  const items = options.map((option) => (
    <MenuItem
      key={props.getOptionValue(option)}
      value={props.getOptionValue(option)}
      sx={{
        height: 30,
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "12px",
          fontWeight: 500,
          color: "#5F6368",
          lineHeight: "26px",
          paddingLeft: "10px",
        }}
        display="flex"
        alignItems="center"
      >
        <Tooltip title={props.getOptionLabel(option)} placement="right-end">
          <Box>{props.getOptionLabel(option)}</Box>
        </Tooltip>
      </Box>
    </MenuItem>
  ));

  return [
    <ListSubheader
      sx={{
        "&.MuiListSubheader-root": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "12px",
          fontWeight: 700,
          color: "#4b4e51",
          lineHeight: "26px",
          padding: "0.5rem 1rem",
          backgroundColor: "#EEEDF3",
        },
      }}
    >
      {label}
    </ListSubheader>,
    items,
    lineBreak && <Divider />,
  ];
};
